// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar--sidebar--c9d046","links":"Sidebar--links--d77743"};